import React, { useState } from 'react';
import { LineChart, StatBlock, SelectInput, ColumnChart, DonutChart } from '../../Components';
import './index.css';
import Order from '../../Assets/Photos/Box.png';
import Add from '../../Assets/Photos/Add.png';
import Graph from '../../Assets/Photos/Graph.png';

const Index = ({ type = 'admin' }) => {
    const [orderGraphnumber, setorderGraphnumber] = useState(7);
    const [destnumber, setDestnumber] = useState(7);
    const [orderDesgin, setorderDesgin] = useState(7);
    const [paymentType, setpaymentType] = useState(7);
    return (
        <div className="dashboardHome">
            <h1 className="primary_heading">Dashboard</h1>
            <h4 className="secondary_heading">Here's what's happening</h4>
            <div className="dashboardHome_stats">
                <StatBlock image={Order} name={'Orders'} number={10495} percentage={0} />
                <StatBlock image={Graph} name={'Revenue'} number={10495} percentage={0} />
                <StatBlock image={Add} name={'New Products'} number={10495} percentage={0} />
            </div>
            <div className="dashboardHome_order">
                <div className="home_head">
                    <h2 className="home_heading">Order units over time</h2>
                    <SelectInput
                        value={orderGraphnumber}
                        changeHandler={(e) => {
                            setorderGraphnumber(e.target.value);
                        }}
                        options={[
                            { name: 'Last 7 Days', value: 7 },
                            { name: 'Last 15 Days', value: 15 },
                            { name: 'Last 30 Days', value: 30 },
                        ]}
                    />
                </div>
                <LineChart
                    name="Orders"
                    lineColor={['rgba(249, 115, 22, 1)']}
                    colors={['#ffffff', 'transparent']}
                    data={[5, 5, 15, 4, 40, 25, 45]}
                    label={[
                        'Sat(27/03)',
                        'Sun(28/03)',
                        'Mon(29/03)',
                        'Tue(30/03)',
                        'Wed(31/03)',
                        'Thr(01/04)',
                        'Fri(02/04)',
                    ]}
                />
            </div>
            <div className="dashboardHome_destination">
                <div className="home_head">
                    <h2 className="home_heading">Top Destinations</h2>
                    <SelectInput
                        value={destnumber}
                        changeHandler={(e) => {
                            setDestnumber(e.target.value);
                        }}
                        options={[
                            { name: 'Last 7 Days', value: 7 },
                            { name: 'Last 15 Days', value: 15 },
                            { name: 'Last 30 Days', value: 30 },
                        ]}
                    />
                </div>
                <LineChart
                    name="Destinations"
                    lineColor={['rgba(249, 115, 22, 1)']}
                    colors={['#ffffff', 'transparent']}
                    data={[5, 5, 15, 4, 40, 25, 45]}
                    label={[
                        'Sat(27/03)',
                        'Sun(28/03)',
                        'Mon(29/03)',
                        'Tue(30/03)',
                        'Wed(31/03)',
                        'Thr(01/04)',
                        'Fri(02/04)',
                    ]}
                />
            </div>
            <div className="dashboardHome_order_data">
                <div className="dashboardHome_order_data_types">
                    <div className="home_head">
                        <h2 className="home_heading">Top Designs</h2>
                        <SelectInput
                            value={orderDesgin}
                            changeHandler={(e) => {
                                setorderDesgin(e.target.value);
                            }}
                            options={[
                                { name: 'Last 7 Days', value: 7 },
                                { name: 'Last 15 Days', value: 15 },
                                { name: 'Last 30 Days', value: 30 },
                            ]}
                        />
                    </div>
                    <ColumnChart
                        data={[4000, 4500, 1500, 2000, 4000, 4500, 1500, 2000]}
                        label={[
                            'Men’s Causals',
                            'Women’s Cloths',
                            'Mug Designs',
                            'Hoodies Design',
                            'Men’s Causals',
                            'Women’s Cloths',
                            'Mug Designs',
                            'Hoodies Design',
                        ]}
                        colors={[
                            'rgba(249, 115, 22, 1)',
                            'rgba(74, 183, 247, 1)',
                            'rgba(1, 144, 36, 1)',
                            'rgba(74, 183, 247, 1)',
                            'rgba(249, 115, 22, 1)',
                            'rgba(74, 183, 247, 1)',
                            'rgba(1, 144, 36, 1)',
                            'rgba(74, 183, 247, 1)',
                            'rgba(249, 115, 22, 1)',
                            'rgba(74, 183, 247, 1)',
                            'rgba(1, 144, 36, 1)',
                            'rgba(74, 183, 247, 1)',
                        ]}
                    />
                </div>
                <div className="dashboardHome_order_data_orders">
                    <div className="home_head">
                        <h2 className="home_heading">COD/Prepaid orders</h2>
                        <SelectInput
                            value={paymentType}
                            changeHandler={(e) => {
                                setpaymentType(e.target.value);
                            }}
                            options={[
                                { name: 'Last 7 Days', value: 7 },
                                { name: 'Last 15 Days', value: 15 },
                                { name: 'Last 30 Days', value: 30 },
                            ]}
                        />
                    </div>
                    <DonutChart
                        label={['Prepaid', 'COD']}
                        colors={['rgba(74, 183, 247, 1)', 'rgba(249, 115, 22, 1)', 'rgba(229, 233, 236, 1)']}
                        data={[915, 700]}
                    />
                </div>
            </div>
            {type === 'admin' && (
                <div className="home_notification">
                    <div className="home_head">
                        <h2 className="home_heading">Notifications</h2>
                    </div>
                    <div className="home_notification_container">
                        <textarea
                            type="text"
                            className="home_notification_input"
                            placeholder="Enter notification here"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Index;
